import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyBiZl9nw1hi07k3M0W-Frj86hJ6FBewMWg",
  authDomain: "dreamofvesper-store.firebaseapp.com",
  projectId: "dreamofvesper-store",
  storageBucket: "dreamofvesper-store.firebasestorage.app",
  messagingSenderId: "525717354444",
  appId: "1:525717354444:web:cc2286f7c2fb46cfa54f69"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Connect to emulators ONLY in development
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
  console.log('🔧 Using Firebase Emulators (Local Development)');
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
}

// Set persistence to LOCAL (stays logged in)
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Persistence error:', error);
});

export default app;